<div class="app-wrapper">
  <xpo-notification [showProgressSpinner]="animationsEnabled"></xpo-notification>
  <div class="xpo-main" xpoProdStyles>
    <router-outlet></router-outlet>
  </div>
</div>